import { getPropertyConfig } from 'app/pages/loanApplication/tabs/propertyAndLoan/EditModal/Content/MainContent/Property/Property.config';
import _ from 'lodash';

import { TransactionDetailType } from 'constants/loanApplication';

import {
  EVERY_LOAN_PURPOSE_FLAGS,
  PURPOSE_INDEPENDENT_PROPERTY_FLAGS,
} from './LoanEditorCustomFormDrawer.constants';
import { flattenGroupFields } from './LoanEditorCustomFormDrawer.entity.utils';

const collectPropertyFieldIds = purposeFlags =>
  new Set(
    _.map(
      flattenGroupFields(
        getPropertyConfig({ ...PURPOSE_INDEPENDENT_PROPERTY_FLAGS, ...purposeFlags }).groups,
      ),
      'fieldId',
    ),
  );

const getAllPurposePropertyFieldIds = _.once(() =>
  collectPropertyFieldIds(EVERY_LOAN_PURPOSE_FLAGS),
);

export const buildPropertyPurposeContext = ({
  isPurchase,
  isRefinance,
  isAdditionalLoan,
  isHelocPurposePurchase,
  transactionDetailType,
}) => ({
  isPurchase: !!isPurchase,
  isRefinance: !!isRefinance,
  isAdditionalLoan: !!isAdditionalLoan,
  isHelocPurposePurchase: !!isHelocPurposePurchase,
  isConstructionToPermanent:
    transactionDetailType === TransactionDetailType.CONSTRUCTION_CONVERSATION_OR_TO_PERMANENT,
});

export const getPurposeHiddenPropertyFieldIds = propertyPurposeContext => {
  if (_.isNil(propertyPurposeContext)) {
    return new Set();
  }

  const visibleFieldIds = collectPropertyFieldIds(propertyPurposeContext);

  return new Set(
    [...getAllPurposePropertyFieldIds()].filter(fieldId => !visibleFieldIds.has(fieldId)),
  );
};
